import React, { useState } from "react";
import classNames from "classnames";
import { Button } from "antd";
import { BemHelper } from "../utils";

export type ToggleButtonOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

type Props = {
  options: ToggleButtonOption[];
  onChange: (value: string) => void;
  value: string;
};

const bem = new BemHelper("toggle-button");

export const ToggleButton: React.FC<Props> = ({ onChange, options, value }) => {
  const [selected, setSelected] = useState<string>(value);

  function handleClick(value: string) {
    setSelected(value);
    onChange(value);
  }

  return (
    <div className={classNames(bem.block())}>
      {options.map(({ value, label, disabled }) => (
        <Button
          className={classNames(
            bem.element("button"),
            selected === value && bem.modifier("active", "button"),
          )}
          key={value}
          onClick={() => handleClick(value)}
          disabled={disabled}
          type='text'
        >
          {label}
        </Button>
      ))}
    </div>
  );
};
